import { Injectable } from '@angular/core';
import { AppSettingsService } from '../appSettings/AppSettingsService';

@Injectable({
    providedIn: 'root'
})
export class EndpointService {
    public static $name: string = 'endpointService';

    constructor(
        private appSettingsService: AppSettingsService
    ) {
    }

    public getEndpoints() {
        const metadata = this.appSettingsService.getMetadata();

        return metadata.endpoints;
    }
}
